import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { usePublicURLContext } from 'utilities/contexts';
import { sendForgotPasswordEmail } from 'api/account';

export default function ProblematicAccount({ emailAddress, message, recover = false }) {


    const publicURL = usePublicURLContext();
    const [ accountRecoverStatus, setAccountRecoverStatus ] = useState(null);

    const handleContactUs = () => {
        window.location = `${publicURL}/home/contact`;
    }

    const handleRecoverAccount = () => {

        if (accountRecoverStatus !== null)
            return false;

        setAccountRecoverStatus(true);

        const forgotPasswordData = new FormData();
        forgotPasswordData.append("Username", emailAddress);

        return sendForgotPasswordEmail(forgotPasswordData, publicURL).then(
            (successResponse) => {
                return;
            },
            (rejectedResponse) => {
                setAccountRecoverStatus(false);
            }
        );
    }

    let button = <></>;

    if (message === null)
        return (<></>);

    if (recover) {
        if (accountRecoverStatus !== false) {
            button = <Button variant="primary" className="ppm-button-primary" type="button" onClick={handleRecoverAccount}>RECOVER ACCOUNT</Button>
            // Augment server message with UI specific message.
            message += '  To receive an email for account recovery click "Recover Account".';
        } else {
            button = <Button variant="primary" className="ppm-button-primary" type="button" onClick={handleContactUs}>CONTACT US</Button>;
            message = 'A problem occured recovering your account,  please contact us for assistance.';
        }

    } else {
        button = <Button variant="primary" className="ppm-button-primary" type="button" onClick={handleContactUs}>CONTACT US</Button>;       
    }
               
    return (
        <>
            <div className='d-flex justify-content-center'>
                <img src={`${process.env.REACT_APP_API_ROOT_URL}/images/icon_oct_exclam.svg`} alt="" style={{ width: "96px" }} />
            </div>

            <div className='d-flex justify-content-center text-center my-5'>
                {message}
            </div>

            <hr />

            <br />

            <div className="d-flex justify-content-center">
                {button}
            </div>
        </>
    );
}